import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './providers/ThemeProvider';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster as SonnerToaster } from 'sonner';
import './index.css';

// Initialize Firebase (imported for side effects)
import './config/firebase';
import { installClientErrorReporting } from './services/clientErrorReporting';

// Uncaught browser errors → backend log (production builds; see the module).
installClientErrorReporting();

// Load tenant separation test utilities in development
if (import.meta.env.DEV) {
  import('./utils/test-tenant-separation');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <ThemeProvider>
            <App />
            <SonnerToaster position="top-right" richColors />
          </ThemeProvider>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
